import { GraphqlError } from 'core/utils/backend-service';
import { PREDEFINED_COMMENT_FORM_ERROR_MAPPINGS } from 'modules/settings/pods/settings-devices/settings-devices-predefined-comments/settings-devices-predefined-comments-form/settings-devices-predefined-comments-form.constants';
import { PredefinedCommentFormValidity } from 'modules/settings/pods/settings-devices/settings-devices-predefined-comments/settings-devices-predefined-comments-form/settings-devices-predefined-comments-form.model';
import { ResultType } from 'modules/devices/domain/api/device-type.api';
import {
    NestedSelectableOptions,
    SelectableOptions,
} from 'commons/components/searchable-dropdown/searchable-dropdown.type';
import { Location } from 'core/contexts/locations/location.model';

export const mapPredefinedCommentsFormErrorsFromAPI = (errors: GraphqlError[]): PredefinedCommentFormValidity =>
    Object.entries(PREDEFINED_COMMENT_FORM_ERROR_MAPPINGS)
        .filter(([, mapping]) => errors?.some((e) => e.extensions.code === mapping.errorCode))
        .map(([, mapping]) => ({ [mapping.field as string]: { state: 'error', type: [mapping.type] } }))
        .reduce((accumulator, current) => ({ ...accumulator, ...current }), {} as PredefinedCommentFormValidity);

export const mapResultTypeOptions = (resultTypes: ResultType[]): SelectableOptions[] =>
    resultTypes.map((rt) => ({ id: rt.id, name: rt.name }));

export const mapLocationOptions = (locations: Location[]): NestedSelectableOptions[] =>
    locations.map((loc) => ({
        id: loc.id,
        name: loc.name,
        children: (loc?.children || []).map((child) => ({ id: child.id, name: child.name })),
    }));

export const mapLocationIds = (locations: Location[]): string[] =>
    locations.flatMap((loc) =>
        loc?.children && loc.children.length > 0 ? loc.children.map((child) => child.id) : [loc.id]
    );
